import IconButton from '../IconButton'
import EditIcon from 'ui-component-library/icons/edit.svg'

type Props = {
  onClick: () => void
  children: string
}

function EditButton({ onClick, children }: Props) {
  return (
    <IconButton Icon={EditIcon} onClick={onClick}>
      {children}
    </IconButton>
  )
}

export default EditButton
